//summary of everything
import React, { useState, useEffect } from 'react';
import { Container, Alert, Button } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import {apiUrl, reportEndDateDiff, reportStartDateDiff} from '../../util/Api';
//import { useSelector } from 'react-redux';
//import { getUserAccounts } from '../../app/slices/UserSlice';
import AppList from '../analytics/components/AppList';

import { toFactDate, fromFactDate, toDisplayDate, alterDate, isFactDate } from '../../util/ChartUtils';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css'

//import AnalyticsNav from '../../components/AnalyticsNav';
//import DashboardCharts from './components/DashboardCharts';
import AccountSummaryCharts from '../analytics/components/AccountSummaryCharts';
import LeftNav from '../../components/LeftNav';
import Onboarding from './Onboarding';

//const SENTIMENT_THRESHOLD = process.env.REACT_APP_SENTIMENT_THRESHOLD || 0.5;

const Dashboard = () => {
    const [errors, setErrors] = useState([]);
    const [account, setAccount] = useState(null);
    const [metrics, setMetrics] = useState([]);
    const [range, setRange] = useState(null);

    const [startDatePicker, setStartDatePicker] = useState(null);
    const [endDatePicker, setEndDatePicker] = useState(null);
    const [showPicker, setShowPicker] = useState(false);

    const [showOnboarding, setShowOnboarding] = useState(false);

    let navigate = useNavigate();
    let { accountKey, startFactDate, endFactDate } = useParams();

    //const currUserAccounts = useSelector(getUserAccounts);
    //const currUserAccount = currUserAccounts.find(a => a.accountKey===accountKey);
    //const currRoleId = currUserAccount ? currUserAccount.roleId : 0;

    const onDateChange = (dates) => {
        const [start, end] = dates;
        //console.log('dates:', dates);
        setStartDatePicker(start);
        setEndDatePicker(end);
        //setShowPicker(false);
        if (end !== null) {
            //console.log('finished')
            setShowPicker(false);
            //window.location = '/account/' + accountKey + '/analytics/dashboard/' + chatbotKey + '/' + toFactDate(start) + '/' + toFactDate(end);
            navigate(`/account/${accountKey}/dashboard/${toFactDate(start)}/${toFactDate(end)}`);
        }
    }

    useEffect(() => {

        let startDate = new Date();
        let endDate = new Date();
        let startFact = startFactDate;
        let endFact = endFactDate;

        if (!isFactDate(endFact)) {
            //console.log('endFactDate is null')
            endDate.setDate(endDate.getDate() - reportEndDateDiff);
            endFact = toFactDate(endDate);
        } else {
            //console.log('endFactDate is not null', endFact)
            endDate = fromFactDate(endFact);
        }

        if (!isFactDate(startFact)) {
            //console.log('startFactDate is null')
            startDate.setDate(endDate.getDate() - reportStartDateDiff);
            startFact = toFactDate(startDate);
        } else {
            //console.log('startFactDate is not null', startFact)
            startDate = fromFactDate(startFact);
        }

        setRange({ startDate: startFact, endDate: endFact });

        document.title = "reconify analytics";

        //setStartDatePicker(startDate);
        //setEndDatePicker(endDate);

        let options = {
            accountKey: accountKey,
            startDate: startFact,
            endDate: endFact
        }
        let isAuthError = false;

        axios.post(apiUrl + '/account-stats/metrics',
            options, { withCredentials: true })
            .then((res) => {
                if (res.data.status === 'ok') {
                    setErrors([]);
                    if (res.data.stats !== null) {
                        setMetrics(res.data.stats);
                    }
                    if (res.data.account !== null) {
                        setAccount(res.data.account);
                        document.title = "reconify analytics " + res.data.account.account;
                    }
                    setShowOnboarding(false)
                } else {
                    setMetrics([]);
                    if (res.data.hasOwnProperty('account') && res.data.account !== null) {
                        setAccount(res.data.account);
                        document.title = "reconify analytics " + res.data.account.account;
                    }
                    if (res.data.hasOwnProperty('appCount') && res.data.appCount < 1) {
                        setShowOnboarding(true)
                    }
                    //setShowOnboarding(true)
                  
                    
                    let errorMsgs = [];
                    let redirectToLogin = false;
                    res.data.errors.forEach((error, i) => {
                        switch (error) {
                            case 'auth-expired':
                            case 'auth-error':
                            case 'no-auth':
                            case 'no-valid-account':
                            case 'no-permissions':
                                //console.log('auth expired');
                                isAuthError = true;
                                redirectToLogin = true;
                                break;
                            case 'no-results':
                                //console.log('no results')
                                errorMsgs.push('There were no matching metrics for the time period.');
                                break;
                            default:
                                //TODO: may want to just ignore - no sense showing anything?
                                errorMsgs.push('There was an error retrieving reports.');
                        }
                    });
                    //don't call setErrors if not logged in as it throws an unmounted error
                    if (redirectToLogin) {
                        navigate('/login');
                        return;
                    }
                    if (!isAuthError) {
                        setErrors(errorMsgs);
                    }
                }
            })
            .catch((err) => {

            });
    }, [accountKey, navigate, startFactDate, endFactDate])

    return (
        <Container fluid>
            <LeftNav isAnalytics={false} accountKey={accountKey} startFactDate={startFactDate} endFactDate={endFactDate} />
            {
                showOnboarding == true ? (
                    <Onboarding/>
                ) : 
                (
                <div>
                    <h4>Account: {account !== null ? (<span className='report-subject'>{account.account}</span>) : null}</h4>
                    {range != null ? (<div className='my-1'>{toDisplayDate(range.startDate)} - {toDisplayDate(range.endDate)}
                        <Button variant='link' size='sm' className='p-0 ms-2' onClick={() => setShowPicker(!showPicker)}><span className='config-btn'>&#x2699;</span></Button>
                    </div>) : null}
                    {showPicker ? (<DatePicker selected={startDatePicker} onChange={onDateChange}
                        startDate={startDatePicker} endDate={endDatePicker} selectsRange
                        minDate={alterDate(new Date(), -30)}
                        maxDate={new Date()} inline />) : (null)}
                    {
                        errors.length > 0 ? (
                            <Alert variant='danger'>
                                {errors.map((err, i) => (<div key={'err.' + i}>{err}</div>))}
                            </Alert>
                        ) : (null)
                    }
                    {
                        metrics.length > 0 ? (
                            <>
                                <AccountSummaryCharts data={metrics} range={range} />
                            </>
                        ) : (
                            null
                        )
                    }
                    <div className='chart-card chart-card-table'>
                        <div>
                            <p>Select an app to view detailed analytics.</p>
                        </div>
                        <AppList showAddApp={true} showErrors={false} />
                    </div>
                    
                </div>
                )
            }
            
        </Container>
    )
}

export default Dashboard